import {
  HEADER_BLOCK_DATA,
  BLOGS_BLOCK_DATA,
  STUDIOS_BLOCK_DATA,
  STORIES_BLOCK_DATA,
  ONE_TAB_BLOCK_DATA,
  NEW_BANNER_WITH_IMAGE_BLOCK_DATA,
} from '../../shared-blocks';

const HOME_PAGE_DATA = [
  {
    componentName: 'headerBlock',
    content: HEADER_BLOCK_DATA,
  },
  {
    componentName: 'studiosBlock',
    content: STUDIOS_BLOCK_DATA,
  },
  {
    componentName: 'oneTabWithImageBlock',
    content: {
      ...ONE_TAB_BLOCK_DATA,
    },
  },
  {
    componentName: 'newBannerWithImageBlock',
    content: {
      ...NEW_BANNER_WITH_IMAGE_BLOCK_DATA,
    },
  },
  {
    componentName: 'storiesBlock',
    content: STORIES_BLOCK_DATA,
  },
  {
    componentName: 'blogsBlock',
    content: BLOGS_BLOCK_DATA,
  },
  {
    componentName: 'toTheTopBlock',
    content: {},
  },
];

export default HOME_PAGE_DATA;
